// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3rOax","productName":"Table_productName__2Xo7x"};